angular.module('impactx.relationView').controller('RelationCtrl',
    ['$scope', '$mdToast', 'TranslationService', 'dataGen', 'ToastService', 'RelationViewHelperService', RelationViewController]);

function RelationViewController($scope, $mdToast, TranslationService, dataGen, ToastService, RelationViewHelperService) {
    var ctrl = this,
        scope = $scope,
        sendToEventHandler,
        modificationCounter = 0;

    $scope.selectedLeft = false;
    $scope.selectedRight = false;
    $scope.selectedLeftPointer = [];
    $scope.selectedRightPointer = [];
    var lastClickedLeft = null;
    var lastClickedRight = null;
    $scope.showDialog = false;
    $scope.currentFilterCall = null;
    $scope.needsBetterFilter = false;
    $scope.filterCounter = 0;
    $scope.sortMode = {value: null};
    $scope.searchAssigned = {};
    $scope.deleteAllLabel = TranslationService.get("deleteAll");
    if ($scope.hasBaseReference && $scope.canSort)
    {
        $scope.labelSortMode = TranslationService.get("sortMode");
        $scope.labelReferenceMode = TranslationService.get("referenceMode");
        $scope.changeModeOpen = false;
    }
    if ($scope.hasBaseReference)
    {
        $scope.labelBaseReference = TranslationService.get("baseReference");
        $scope.labelReferencePlus = TranslationService.get("referencePlus");
        $scope.labelReferenceMinus = TranslationService.get("referenceMinus");
        if (!$scope.canSort)
        {
            $scope.sortMode.value = false;
        }
    }

    if ($scope.canSort)
    {
        $scope.sortMode.value = true;
        $scope.labelMoveUp = TranslationService.get("moveUp");
        $scope.labelMoveDown = TranslationService.get("moveDown");
    }

    if ($scope.availableEntryPoint) {
        $scope.filteredLeft = {
            getItemAtIndex: function () {
                return null
            }, getLength: function () {
                return 0
            }
        };
    }

    /**
     * Retrieves a list of src groups used by this relation.
     *
     * @return {*} an array of groups used by this relation
     */
    $scope.getAssignedGroups = function() {

        if($scope.listOrder && $scope.listOrder.length > 0) {

            if(typeof $scope.listOrder === 'object') {
                return $scope.listOrder;
            }

            return $scope.listOrder.split(/,/);
        }


        return ['default'];
    };

    this.escapeRegexp = function(string) {
        return string ? string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') : string;
    };

    /**
     * Retrives visible selected items.
     *
     * @return {Array.<T>|*|string|Array.<*>|Array} currently selected items
     */
    ctrl.getVisibleSelectedItems = function() {
        return $scope.filteredRight;
    };

    /**
     * Increments modification counter.
     *
     * @param sourceMethodName parameters for debugging.
     */
    ctrl.incrementModificationCounter = function(sourceMethodName) {
        modificationCounter += 1;
    };

    /**
     * Retrieves current modification counter value
     * @return {number} current modification counter value
     */
    ctrl.getModificationCounter = function() {
        return modificationCounter;
    };


    /**
     * Sends event to the given handler object.
     *
     * @param handlerObj handler object
     * @param eventName event name
     * @param data data for event
     * @param eventSource event source object
     */
    sendToEventHandler = function(handlerObj, eventName, data, eventSource) {
        if(handlerObj) {
            if(handlerObj.hasOwnProperty('onUXEvent') && typeof handlerObj.onUXEvent === 'function') {

                handlerObj.onUXEvent(eventName, data, eventSource);
            }
        }
    };

    $scope.getRelationId = function() {
        return $scope.relationId;
    };

    if($scope.externalSearchRight) {
        $scope.$watch(function() {
                return $scope.externalSearchRight.value;
            },
            function(newValue, oldValue) {
                if(newValue != oldValue) {
                    $scope.filterRight($scope.externalSearchRight.value);
                }
            });
    }

    $scope.label_accept = TranslationService.get("accept");
    $scope.label_search = TranslationService.get("search");

    $scope.getDeleteLabel = function() {
        return TranslationService.get("unassigned").replace("^0", $scope.lastDeleted.value);
    };

    $scope.showDeletionToast = function() {
        ToastService.openActionToast($scope.getDeleteLabel(), TranslationService.get('revert'), $scope.revertDeletion);
    };

    $scope.showAllDeletionToast = function() {
        ToastService.openActionToast(TranslationService.get("unassignedAll"), TranslationService.get('revert'), $scope.revertAllDeletion);
    };

    $scope.revertDeletion = function() {
        $scope.assignOne($scope.lastDeleted);
        $mdToast.hide();
        if($scope.changedMarker) {
            $scope.changedMarker.value = true;
        }

        sendToEventHandler($scope.ixEventHandler, 'rv.revertDeletion', ctrl.getVisibleSelectedItems(), $scope);
        ctrl.incrementModificationCounter('revertDeletion');
    };

    $scope.revertAllDeletion = function() {
        for (var i = 0; i< $scope.lastAllDeleted.length; i++)
        {
            $scope.assignOne($scope.lastAllDeleted[i]);
        }
        $mdToast.hide();
        if($scope.changedMarker) {
            $scope.changedMarker.value = true;
        }

        sendToEventHandler($scope.ixEventHandler, 'rv.revertDeletion', ctrl.getVisibleSelectedItems(), $scope);
        ctrl.incrementModificationCounter('revertDeletion');
    };

    $scope.toggleDialog = function() {
        $scope.showDialog = !$scope.showDialog;

        if($scope.showDialog) {
            ToastService.hideExistingToast();
            if ($scope.relation && $scope.availableEntryPoint) {
                $scope.filteredLeft = {
                    getItemAtIndex: function () {
                        return null
                    }, getLength: function () {
                        return 0
                    }
                };
            }
            if ($scope.relation && $scope.relation.firstFilter) {
                $scope.relation.available = [];
                $scope.relation.firstFilter.selected = null;
            }
            $scope.filterLeft($scope.searchLeft);

            placePanel();
        }

        sendToEventHandler($scope.ixEventHandler, 'rv.toggleDialog', null, $scope);
        ctrl.incrementModificationCounter('toggleDialog');
    };

    function placePanel() {
        var mainView = angular.element('#ix-main-view');
        var mainViewBounding = mainView[0].getBoundingClientRect();
        var button = angular.element('#' + $scope.relationId);
        var dialog = angular.element('#dialog' + $scope.relationId);
        var buttonBounding = button[0].getBoundingClientRect();

        if (mainViewBounding.bottom < buttonBounding.bottom + 450 && (mainViewBounding.top + 80) < buttonBounding.bottom - 450) {
            dialog.css({
                position: 'relative',
                top: -450 + 'px'
            })
        }
        else {
            dialog.css({
                position: 'relative',
                top: 64 + 'px'
            })
        }
    }

    $scope.unassignOneItem = function(event, index, id, pointer, item) {
        $scope.selectRight(event, index, id, pointer);
        $scope.lastDeleted = item;
        if (!$scope.relation.removed) {
            $scope.relation.removed = [];
        }
        $scope.relation.removed.push(item);

        $scope.showDeletionToast(item);
        $scope.unassignAll();

        sendToEventHandler($scope.ixEventHandler, 'rv.unassignOne', $scope.filteredRight, $scope);
        ctrl.incrementModificationCounter('unassignOneItem');
    };

    $scope.unassignAllItems = function(event) {
        var assignedCopy = [];
        for (var i=0; i < $scope.relation.assigned.length; i++)
        {
            var item = $scope.relation.assigned[i];
            if (!item.readOnly) {
                event.ctrlKey = 1;
                $scope.selectRight(event, i, item.id, item.xOrder);
                if (!$scope.relation.removed) {
                    $scope.relation.removed = [];
                }
                $scope.relation.removed.push(item);
                assignedCopy.push(item)
            }
        }
        $scope.lastAllDeleted = assignedCopy;

        $scope.showAllDeletionToast();
        $scope.unassignAll();

        sendToEventHandler($scope.ixEventHandler, 'rv.unassignAll', $scope.filteredRight, $scope);
        ctrl.incrementModificationCounter('unassignAllItems');
    };

    var stepSize = 500;
    $scope.fetchResults = function(filterCounter, search, data, maxSize) {
        //no new filter called? we don't want to override newer filter
        if (filterCounter && filterCounter === $scope.filterCounter) {
            $scope.selectedLeftPointer = [];
            $scope.selectedLeft = [];
            $scope.relation.available = data.data.entries;
            //$scope.filteredLeft = data.data.entries;
            $scope.filteredLeft = {
                //needs to be init by first call
                length: maxSize,
                toLoad: stepSize,
                getItemAtIndex: function (index) {
                    if (index > $scope.relation.available.length) {
                        this.fetchMoreItems_(index);
                        return null;
                    }

                    return $scope.relation.available[index];
                },

                getLength: function () {
                    return Math.min($scope.relation.available.length + 5, this.length);
                },

                fetchMoreItems_: function (index) {
                    if (this.toLoad < index && this.toLoad < this.length) {
                        this.toLoad = Math.min(this.toLoad + stepSize, this.length);
                        var currentFilterCounter = $scope.filterCounter;
                        $scope.needsBetterFilter = false;
                        if ($scope.currentFilterCall)
                        {
                            $scope.currentFilterCall = null;
                        }
                        $scope.currentFilterCall = dataGen.postAsForm({}, {searchText: search,
                                assigned: !$scope.secondRelation ? $scope.relation.assigned : $scope.relation.assigned.concat($scope.secondRelation.assigned),
                                startIndex: $scope.relation.available.length, stepSize: stepSize, baseId: $scope.baseId,
                                additionalFilterId: $scope.additionalFilter && $scope.additionalFilter.selected ? $scope.additionalFilter.selected.id : 0},
                            $scope.availableEntryPoint, true, true).then(function(data){
                                if (currentFilterCounter === $scope.filterCounter) {
                                    $scope.relation.available = $scope.relation.available.concat(data.data.entries);
                                    $scope.currentFilterCall = null;
                                }
                            });
                    }
                }
            };
            $scope.currentFilterCall = null;
        }
    };

    $scope.filterAdditional = function(selected) {
        $scope.additionalFilter.selected = selected;
        $scope.filterLeft($scope.searchLeft);
    };

    $scope.filterLeft = function(filter) {
        if($scope.availableEntryPoint)
        {
            var currentFilterCounter = ++$scope.filterCounter;
            if ($scope.currentFilterCall)
            {
                $scope.currentFilterCall = null;
            }
            if ((filter && filter.length >= ($scope.minFilterLength ? $scope.minFilterLength : 0)) ||
                (!filter && (!$scope.minFilterLength || $scope.minFilterLength == 0)))
            {
                $scope.filteredLeft = {getItemAtIndex: function(){return null}, getLength: function(){return 0}};
                $scope.needsBetterFilter = false;
                $scope.currentFilterCall = dataGen.postAsForm({}, {searchText: filter,
                    assigned: !$scope.secondRelation ? $scope.relation.assigned : $scope.relation.assigned.concat($scope.secondRelation.assigned),
                    startIndex: 0, stepSize: 0, baseId: $scope.baseId,
                    additionalFilterId: $scope.additionalFilter && $scope.additionalFilter.selected ? $scope.additionalFilter.selected.id : 0},
                    $scope.availableEntryPoint, true, true).then(function(data){
                        var maxSize = data.data.maxSize;
                        $scope.currentFilterCall = dataGen.postAsForm({}, {searchText: filter,
                                assigned: !$scope.secondRelation ? $scope.relation.assigned : $scope.relation.assigned.concat($scope.secondRelation.assigned),
                                startIndex: 0, stepSize: stepSize, baseId: $scope.baseId,
                                additionalFilterId: $scope.additionalFilter && $scope.additionalFilter.selected ? $scope.additionalFilter.selected.id : 0},
                            $scope.availableEntryPoint, true, true).then(function(data){
                                return $scope.fetchResults(currentFilterCounter, filter, data, maxSize)
                    })});
            }
            else
            {
                $scope.needsBetterFilterMessage = TranslationService.get("minLengthAsyncInputConfigurable").replace("^0", $scope.minFilterLength);
                $scope.needsBetterFilter = true;
                $scope.filteredLeft = {getItemAtIndex: function(){return null}, getLength: function(){return 0}};
            }
        }
        else {
            $scope.selectedLeft = [];
            $scope.selectedLeftPointer = [];
            if(filter != undefined && filter.length > 0) {
                var r = new RegExp(ctrl.escapeRegexp(filter), 'i');
                $scope.filteredLeft = $scope.relation.available.filter(function(el) {
                    return r.test(el.value);
                });
            }
            else {
                $scope.filteredLeft = $scope.relation.available;
            }
        }

        ctrl.incrementModificationCounter('filterLeft');
    };
    $scope.filterRight = function(filter) {

        if(filter != undefined && filter.length > 0) {
            var r = new RegExp(ctrl.escapeRegexp(filter), 'i');
            $scope.filteredRight = $scope.relation.assigned.filter(function(el) {
                return r.test(el.value);
            });
        }
        else {
            $scope.filteredRight = $scope.relation.assigned;
        }

        ctrl.incrementModificationCounter('filterRight');
    };

    $scope.$on('rv.addData', function(evt, data) {
        var dataToAdd, doAssign, newData,
            assignedGroups,
            currentModificationCounter = ctrl.getModificationCounter();

        if(data && data.receiverId && data.receiverId === $scope.relationId) {

            dataToAdd = data.data;

            if(data.type === 'replaceForSrc') {

                newData = RelationViewHelperService.replaceForSrc(data.srcId, $scope.relation.assigned, dataToAdd);

                if(newData && newData.hasOwnProperty('length')) {
                    doAssign = true;
                    if(currentModificationCounter < ctrl.getModificationCounter()) {
                        //Something changed during processing items ... Just do it again.
                        newData = RelationViewHelperService.replaceForSrc(data.srcId, $scope.relation.assigned, dataToAdd);

                        doAssign = (newData && newData.hasOwnProperty('length'));
                    }

                    //We hope that it's performed fast.
                    assignedGroups = $scope.getAssignedGroups();

                    if(assignedGroups.length > 1) {
                        heap_sort_value(newData, assignedGroups);
                    }

                    if(doAssign) {
                        $scope.relation.assigned = newData;
                        $scope.filterRight();
                    }
                }
            }
        }
    });


    $scope.selectLeft = function(event, index, id, pointer) {
        if(event.ctrlKey != 1) {
            $scope.selectedLeft = [];
            $scope.selectedLeftPointer = [];
        }
        $scope.selectedLeft[index] = !$scope.selectedLeft[index];
        var pointerIndex = $scope.selectedLeftPointer.indexOf(pointer);
        pointerIndex > -1
            ? $scope.selectedLeftPointer.splice(pointerIndex, 1)
            : $scope.selectedLeftPointer.push(pointer);
        var lastClicked = lastClickedLeft;
        if(event.shiftKey != 1 || lastClickedLeft == null) {
            lastClickedLeft = index;
        }
        if(event.shiftKey == 1 && lastClicked != null) {
            var indexIndicator = lastClicked;
            if(indexIndicator <= index) {
                while(indexIndicator < index) {
                    $scope.selectedLeft[indexIndicator] = true;
                    if ($scope.availableEntryPoint) {
                        $scope.selectedLeftPointer.push($scope.filteredLeft.getItemAtIndex(indexIndicator).xOrder);
                    } else {
                        $scope.selectedLeftPointer.push($scope.filteredLeft[indexIndicator].xOrder);
                    }
                    indexIndicator++;
                }
            }
            else {
                index = index + 1;
                while(index <= indexIndicator) {
                    $scope.selectedLeft[index] = true;
                    if ($scope.availableEntryPoint) {
                        $scope.selectedLeftPointer.push($scope.filteredLeft.getItemAtIndex(index).xOrder);
                    } else {
                        $scope.selectedLeftPointer.push($scope.filteredLeft[index].xOrder);
                    }
                    index++;
                }
            }
        }
        ctrl.incrementModificationCounter('selectLeft');
    };

    $scope.selectRight = function(event, index, id, pointer) {

        if(event.ctrlKey != 1) {
            $scope.selectedRight = [];
            $scope.selectedRightPointer = [];
        }
        $scope.selectedRight[index] = !$scope.selectedRight[index];
        var pointerIndex = $scope.selectedRightPointer.indexOf(pointer);
        pointerIndex > -1
            ? $scope.selectedRightPointer.splice(pointerIndex, 1)
            : $scope.selectedRightPointer.push(pointer);
        var lastClicked = lastClickedRight;
        if(event.shiftKey != 1 || lastClickedRight == null) {
            lastClickedRight = index;
        }
        if(event.shiftKey == 1 && lastClicked != null) {
            var indexIndicator = lastClicked;
            if(indexIndicator <= index) {
                while(indexIndicator < index) {
                    $scope.selectedRight[indexIndicator] = true;
                    $scope.selectedRightPointer.push($scope.filteredRight[indexIndicator].xOrder);
                    indexIndicator++;
                }
            }
            else {
                index = index + 1;
                while(index <= indexIndicator) {
                    $scope.selectedRight[index] = true;
                    $scope.selectedRightPointer.push($scope.filteredRight[index].xOrder);
                    index++;
                }
            }
        }
        ctrl.incrementModificationCounter('selectRight');
    };

    var reAdjustXOrder = function(arrayToAdjust) {
        var length = arrayToAdjust.length;
        if(length > 0) {
            arrayToAdjust[0].xOrder = 0;
        }
        for(var i = 0; i < length - 1; i++) {
            arrayToAdjust[i + 1].xOrder = arrayToAdjust[i].xOrder + 1;
        }
    };
    $scope.assignAllXOrder = function() {
        setFormAsDirty();

        insertionSort($scope.selectedLeftPointer);
        //$scope.selectedLeftPointer.sort(function(a, b) {return a - b;});
        var assignedStartLength = $scope.relation.assigned.length;
        var selectedLength = $scope.selectedLeftPointer.length;
        var regRight = new RegExp(ctrl.escapeRegexp($scope.searchRight), 'i');
        var differRight = $scope.relation.assigned != $scope.filteredRight;
        var differLeft = $scope.relation.available != $scope.filteredLeft;
        for(var i = 0; i < selectedLength; i++) {
            var currentPointer = $scope.selectedLeftPointer[i];
            var toMoveItem = $scope.relation.available[currentPointer];
            $scope.relation.available[toMoveItem.xOrder] = undefined;
            toMoveItem.xOrder = assignedStartLength + i;
            $scope.relation.assigned.push(toMoveItem);
            if(differRight && regRight.test(toMoveItem.value)) $scope.filteredRight.push(toMoveItem);
        }
        $scope.relation.available = $scope.relation.available.filter(function(el) {
            return el;
        });
        if($scope.secondRelation) {
            $scope.secondRelation.available = $scope.relation.available;
        }
        reAdjustXOrder($scope.relation.available);
        $scope.selectedLeftPointer = [];
        $scope.selectedLeft = [];
        $scope.selectedRightPointer = [];
        $scope.selectedRight = [];
        if (!$scope.availableEntryPoint) {
            differLeft ? $scope.filterLeft($scope.searchLeft) : $scope.filteredLeft = $scope.relation.available;
        }
        reAdjustXOrder($scope.relation.assigned);

        ctrl.incrementModificationCounter('assignAllXOrder');
    };
    $scope.assignOne = function(item) {
        setFormAsDirty();

        var assignedStartLength = $scope.relation.assigned.length;
        var regRight = new RegExp(ctrl.escapeRegexp($scope.searchRight), 'i');
        var differRight = $scope.relation.assigned != $scope.filteredRight;
        var differLeft = $scope.relation.available != $scope.filteredLeft;
        var toMoveItem = item;
        $scope.relation.available[toMoveItem.xOrder] = undefined;
        toMoveItem.xOrder = assignedStartLength;
        $scope.relation.assigned.push(toMoveItem);
        if($scope.useXOrder) {
            if(differRight && regRight.test(toMoveItem.value)) $scope.filteredRight.push(toMoveItem);
            $scope.relation.available = $scope.relation.available.filter(function(el) {
                return el;
            });
            if($scope.secondRelation) {
                $scope.secondRelation.available = $scope.relation.available;
            }
            reAdjustXOrder($scope.relation.available);
            differLeft ? $scope.filterLeft($scope.searchLeft) : $scope.filteredLeft = $scope.relation.available;
            reAdjustXOrder($scope.relation.assigned);
        }
        else {
            $scope.relation.available = $scope.relation.available.filter(function(el) {
                return el;
            });
            if($scope.secondRelation) {
                $scope.secondRelation.available = $scope.relation.available;
            }
            reAdjustXOrder($scope.relation.available);

            differLeft ? $scope.filterLeft($scope.searchLeft) : $scope.filteredLeft = $scope.relation.available;
            //todo: better idea of sorting? slow for few elements to insert, fast for a lot of elements compared to single inserts.
            heap_sort_value($scope.relation.assigned, $scope.getAssignedGroups());
            reAdjustXOrder($scope.relation.assigned);
            $scope.filterRight($scope.searchRight);
        }
        $scope.selectedLeftPointer = [];
        $scope.selectedLeft = [];
        $scope.selectedRightPointer = [];
        $scope.selectedRight = [];

        sendToEventHandler($scope.ixEventHandler, 'rv.assignOne', $scope.filteredRight, $scope);
        ctrl.incrementModificationCounter('assignOne');
    };
    function setFormAsDirty() {
        if($scope.formController) {
            $scope.formController.$setDirty();
        }
    }

    $scope.assignAllAlphabetic = function() {
        setFormAsDirty();

        insertionSort($scope.selectedLeftPointer);
        //$scope.selectedLeftPointer.sort(function(a, b) {return a - b;});
        var assignedStartLength = $scope.relation.assigned.length;
        var selectedLength = $scope.selectedLeftPointer.length;
        var regRight = new RegExp(ctrl.escapeRegexp($scope.searchRight), 'i');
        var differRight = $scope.relation.assigned != $scope.filteredRight;
        var differLeft = $scope.relation.available != $scope.filteredLeft;
        for(var i = 0; i < selectedLength; i++) {
            var currentPointer = $scope.selectedLeftPointer[i];
            var toMoveItem = $scope.relation.available[currentPointer];
            $scope.relation.available[toMoveItem.xOrder] = undefined;
            toMoveItem.xOrder = assignedStartLength + i;
            $scope.relation.assigned.push(toMoveItem);
            //todo: this line is needed if we don't insert alphabetically in left side.
            //if (differLeft && regLeft.test(toMoveItem.value))  $scope.filteredLeft.push(toMoveItem);
        }
        $scope.relation.available = $scope.relation.available.filter(function(el) {
            //todo: problem is that this filter is faster for items that are undefined. So moving most of the elements is faster
            // than moving few. Standard should be moving few, so this should be optimized for this.
            return el;
        });
        if($scope.secondRelation) {
            $scope.secondRelation.available = $scope.relation.available;
        }
        reAdjustXOrder($scope.relation.available);
        $scope.selectedLeftPointer = [];
        $scope.selectedLeft = [];
        $scope.selectedRightPointer = [];
        $scope.selectedRight = [];
        //only need to update the unassigned items if we don't have an available entry point (which willl override this anyways)
        if (!$scope.availableEntryPoint) {
            differLeft ? $scope.filterLeft($scope.searchLeft) : $scope.filteredLeft = $scope.relation.available;
        }
        //todo: better idea of sorting? slow for few elements to insert, fast for a lot of elements compared to single inserts.
        heap_sort_value($scope.relation.assigned, $scope.getAssignedGroups());
        reAdjustXOrder($scope.relation.assigned);
        $scope.filterRight($scope.searchRight);
        ctrl.incrementModificationCounter('assignAllAlphabetic');
    };

    $scope.assignAll = function() {
        setFormAsDirty();

        if($scope.useXOrder) {
            $scope.assignAllXOrder();
        }
        else {
            $scope.assignAllAlphabetic();
        }
        if($scope.changedMarker) {
            $scope.changedMarker.value = true;
        }
        $scope.toggleDialog();

        sendToEventHandler($scope.ixEventHandler, 'rv.assignAll', $scope.filteredRight, $scope);
        ctrl.incrementModificationCounter('assignAll');
    };

    scope.unassignAll = function() {
        setFormAsDirty();

        insertionSort($scope.selectedRightPointer);
        //$scope.selectedLeftPointer.sort(function(a, b) {return a - b;});
        var availableStartLength = impactX.isDefined($scope, 'relation.available.length');
        var selectedLength = $scope.selectedRightPointer.length;
        // var regLeft = new RegExp(ctrl.escapeRegexp($scope.searchLeft), 'i');
        var differRight = $scope.relation.assigned != $scope.filteredRight;
        // var differLeft = $scope.relation.available != $scope.filteredLeft;
        if ($scope.hasBaseReference)
        {
            var assignedLength = $scope.relation.assigned.length;
            for(var j = 0; j < selectedLength; j++) {
                for (var k = $scope.selectedRightPointer[j] + 1; k < assignedLength; k++) {
                    if ($scope.relation.assigned[k].baseReference > 0) {
                        $scope.relation.assigned[k].baseReference--;
                    }
                }

            }
        }
        for(var i = 0; i < selectedLength; i++) {
            var currentPointer = $scope.selectedRightPointer[i];
            var toMoveItem = $scope.relation.assigned[currentPointer];
            $scope.relation.assigned[toMoveItem.xOrder] = undefined;
            //only need to update the unassigned items if we don't have an available entry point (which willl override this anyways)
            if (!$scope.availableEntryPoint)
            {
                toMoveItem.xOrder = availableStartLength + i;
                $scope.relation.available.push(toMoveItem);
            }
            //todo: this line is needed if we don't insert alphabetically in left side.
            //if (differLeft && regLeft.test(toMoveItem.value))  $scope.filteredLeft.push(toMoveItem);
        }
        $scope.relation.assigned = $scope.relation.assigned.filter(function(el) {
            //todo: problem is that this filter is faster for items that are undefined. So moving most of the elements is faster
            // than moving few. Standard should be moving few, so this should be optimized for this.
            return el;
        });
        reAdjustXOrder($scope.relation.assigned);
        $scope.selectedRightPointer = [];
        $scope.selectedRight = [];
        $scope.selectedLeftPointer = [];
        $scope.selectedLeft = [];
        differRight ? $scope.filterRight($scope.searchRight) : $scope.filteredRight = $scope.relation.assigned;
        //todo: better idea of sorting? slow for few elements to insert, fast for a lot of elements compared to single inserts.
        //only need to update the unassigned items if we don't have an available entry point (which willl override this anyways)
        if (!$scope.availableEntryPoint) {
            heap_sort_value($scope.relation.available);
            reAdjustXOrder($scope.relation.available);
            $scope.filterLeft($scope.searchLeft);
        }
        if($scope.changedMarker) {
            $scope.changedMarker.value = true;
        }

        sendToEventHandler($scope.ixEventHandler, 'rv.unassignAll', $scope.filteredRight, $scope);
        ctrl.incrementModificationCounter('unassignAll');
    };

    var insert = function(element, array) {
        array.length > 0 ? array.splice(locationOf(element, array), 0, element) : array.push(element);
        return array;
    };

    var locationOf = function(element, array, start, end) {
        start = start || 0;
        end = end || array.length;
        var pivot = parseInt(start + (end - start) / 2, 10);
        if(end - start <= 1 || array[pivot] === element) {
            if(array[pivot].value < element.value) {
                pivot++;
            }
            return pivot;
        }
        if(array[pivot].value < element.value) {
            return locationOf(element, array, pivot, end);
        }
        else {
            return locationOf(element, array, start, pivot);
        }
    };

    $scope.totalDown = function() {
        insertionSort($scope.selectedRightPointer);
        $scope.selectedRight = [];
        var selectedLength = $scope.selectedRightPointer.length;
        var tempPointer = [];
        var assignedLength = $scope.relation.assigned.length;
        if(selectedLength > 0) {
            var selectedItems = [];
            for(var i = 0; i < selectedLength; i++) {
                var currentPointer = $scope.selectedRightPointer[i];
                var toMoveItem = $scope.relation.assigned[currentPointer];
                $scope.relation.assigned[toMoveItem.xOrder] = undefined;
                $scope.relation.assigned.push(toMoveItem);
                $scope.selectedRight[assignedLength - i - 1] = true;
                tempPointer.push(assignedLength - i - 1);
            }
        }
        $scope.relation.assigned = $scope.relation.assigned.filter(function(el) {
            return el;
        });
        $scope.selectedRightPointer = tempPointer;
        reAdjustXOrder($scope.relation.assigned);
        $scope.filteredRight = $scope.relation.assigned;
        ctrl.incrementModificationCounter('totalDown');
    };
    $scope.totalUp = function() {
        insertionSort($scope.selectedRightPointer);
        $scope.selectedRight = [];
        var selectedLength = $scope.selectedRightPointer.length;
        var tempPointer = [];
        var firstElements = [];
        if(selectedLength > 0) {
            var selectedItems = [];
            for(var i = 0; i < selectedLength; i++) {
                var currentPointer = $scope.selectedRightPointer[i];
                var toMoveItem = $scope.relation.assigned[currentPointer];
                firstElements[i] = toMoveItem;
                $scope.relation.assigned[toMoveItem.xOrder] = undefined;
                $scope.selectedRight[i] = true;
                tempPointer.push(i);
            }
        }
        $scope.relation.assigned = $scope.relation.assigned.filter(function(el) {
            return el;
        });
        $scope.relation.assigned = firstElements.concat($scope.relation.assigned);
        $scope.selectedRightPointer = tempPointer;
        reAdjustXOrder($scope.relation.assigned);
        $scope.filteredRight = $scope.relation.assigned;
        ctrl.incrementModificationCounter('totalUp');
    };
    //todo: this is sooooo stupid...
    var reAdjustSelected = function(selectedArray, pointerArray, adjust) {
        var tempArray = [];
        var key;
        for(key in selectedArray) {
            if(selectedArray[parseInt(key)]) {
                tempArray[parseInt(key) + parseInt(adjust)] = true;
            }
        }
        $scope.selectedRight = tempArray;
        for(key in pointerArray) {
            pointerArray[parseInt(key)] = pointerArray[parseInt(key)] + parseInt(adjust);
        }
    };
    $scope.oneUp = function() {
        $scope.selectedRightPointer.sort(function(a, b) {
            return a - b;
        });
        var selectedLength = $scope.selectedRightPointer.length;
        if(selectedLength > 0 && $scope.selectedRightPointer[0] > 0) {
            for(var i = 0; i < selectedLength; i++) {
                var currentPointer = $scope.selectedRightPointer[i];
                var toMoveItem = $scope.relation.assigned[currentPointer];
                toMoveItem.xOrder--;
                $scope.relation.assigned[currentPointer] = $scope.relation.assigned[currentPointer - 1];
                $scope.relation.assigned[currentPointer].xOrder++;
                $scope.relation.assigned[currentPointer - 1] = toMoveItem;
            }
            reAdjustSelected($scope.selectedRight, $scope.selectedRightPointer, -1);
            $scope.filteredRight = $scope.relation.assigned;
        }
        ctrl.incrementModificationCounter('oneUp');
    };

    $scope.oneUpSelect = function(index) {
        var toMoveItem = $scope.relation.assigned[index];
        if (index > 0){
            toMoveItem.xOrder--;
            $scope.relation.assigned[index] = $scope.relation.assigned[index - 1];
            $scope.relation.assigned[index].xOrder++;
            $scope.relation.assigned[index - 1] = toMoveItem;

            $scope.filteredRight = $scope.relation.assigned;
            ctrl.incrementModificationCounter('oneUp');
            if($scope.hasBaseReference && index === toMoveItem.baseReference && toMoveItem.baseReference > 0)
            {
                toMoveItem.baseReference--;
            }
        }
    };

    $scope.oneDownSelect = function(index) {
        var toMoveItem = $scope.relation.assigned[index];
        if (index < $scope.relation.assigned.length - 1){
            toMoveItem.xOrder++;
            $scope.relation.assigned[index] = $scope.relation.assigned[index + 1];
            $scope.relation.assigned[index].xOrder--;
            $scope.relation.assigned[index + 1] = toMoveItem;

            $scope.filteredRight = $scope.relation.assigned;
            ctrl.incrementModificationCounter('oneDown');
            if($scope.hasBaseReference && index + 1 === $scope.filteredRight[index].baseReference)
            {
                $scope.filteredRight[index].baseReference--;
            }
        }
    };

    $scope.baseRefUp = function(index) {
        if (index > scope.relation.assigned[index].baseReference) {
            $scope.relation.assigned[index].baseReference++;
            ctrl.incrementModificationCounter('baseRefUp');
        }
    };

    $scope.baseRefDown = function(index) {
        if ($scope.relation.assigned[index].baseReference > 0) {
            $scope.relation.assigned[index].baseReference--;
            ctrl.incrementModificationCounter('baseRefDown');
        }
    };

    $scope.oneDown = function() {
        $scope.selectedRightPointer.sort(function(a, b) {
            return b - a;
        });
        var selectedLength = $scope.selectedRightPointer.length;
        if(selectedLength > 0 && $scope.selectedRightPointer[0] < $scope.relation.assigned.length - 1) {
            for(var i = 0; i < selectedLength; i++) {
                var currentPointer = $scope.selectedRightPointer[i];
                var toMoveItem = $scope.relation.assigned[currentPointer];
                toMoveItem.xOrder++;
                $scope.relation.assigned[currentPointer] = $scope.relation.assigned[currentPointer + 1];
                $scope.relation.assigned[currentPointer].xOrder--;
                $scope.relation.assigned[currentPointer + 1] = toMoveItem;
            }
            reAdjustSelected($scope.selectedRight, $scope.selectedRightPointer, 1);
            $scope.filteredRight = $scope.relation.assigned;
        }
        ctrl.incrementModificationCounter('oneDown');
    };
    $scope.resetLeft = function() {
        $scope.searchLeft = undefined;
        ctrl.incrementModificationCounter('resetLeft');
    };

    function swap_value(data, i, j) {
        var tmp = data[i];
        data[i] = data[j];
        data[j] = tmp;
    }

    /**
     * Default comparison function
     * @param item1 first item to compare
     * @param item2 second item to compare
     * @return {boolean} comparison result
     */
    function defaultComparisonFunction(item1, item2) {

        return item1.value > item2.value;
    }

    /**
     * Creates custom comparison function.
     *
     * @param groupList group list
     * @return {Function} comparison function
     */
    function createComparisonFunction(groupList) {

        if(groupList && groupList.length > 1) {
            //Using closure to bind src group list
            return (function(srcSort) {
                return function (item1, item2) {
                    var src1, src2, idx1, idx2;

                    if(srcSort && srcSort.length > 1) {
                        src1 = item1.src || 'default';
                        src2 = item2.src || 'default';

                        if((item1.value === item2.value) || (item1.id && item1.id === item2.id)) {

                            //Same source
                            if(src1 === src2) {
                                return item1.value > item2.value;
                            }

                            idx1 = srcSort.indexOf(src1);
                            idx2 = srcSort.indexOf(src2);
                            //Only for defined!!!
                            if(idx1 >= 0 && idx2 >= 0) {
                                return idx1 > idx2;
                            }
                        }

                        if(src1 === 'default' && src2 !== 'default') {
                            return false;
                        }

                        if(src1 !== 'default' && src2 === 'default') {
                            return true;
                        }
                    }

                    return defaultComparisonFunction(item1, item2);
                };
            }(groupList));
        }

        return defaultComparisonFunction;
    }

    /**
     * Sorts given array using heap-sort algorithm.
     * @param arr array to sort
     * @param groupList (optional) list of groups to consider
     */
    function heap_sort_value(arr, groupList) {
        var end,
            compFunc = createComparisonFunction(groupList);

        put_array_in_heap_order_value(arr, compFunc);

        end = arr.length - 1;

        while(end > 0) {
            swap_value(arr, 0, end);
            sift_element_down_heap_value(arr, 0, end, compFunc);
            end -= 1
        }
    }

    function put_array_in_heap_order_value(arr, compFunc) {
        var i;
        i = arr.length / 2 - 1;
        i = Math.floor(i);
        while(i >= 0) {
            sift_element_down_heap_value(arr, i, arr.length, compFunc);
            i -= 1;
        }
    }

    function sift_element_down_heap_value(heap, i, max, compFunc) {
        var i_big, c1, c2;

        if(!compFunc) {
            compFunc = defaultComparisonFunction;
        }

        while(i < max) {
            i_big = i;
            c1 = 2 * i + 1;
            c2 = c1 + 1;
            if(c1 < max && compFunc(heap[c1], heap[i_big])) {
                i_big = c1;
            }
            if(c2 < max && compFunc(heap[c2], heap[i_big])) {
                i_big = c2;
            }
            if(i_big == i) {
                return;
            }
            swap_value(heap, i, i_big);
            i = i_big;
        }
    }

    function insertionSort(unsortedList) {
        var i, j, tmp, len = unsortedList.length;

        for(i = 0; i < len; i++) {
            tmp = unsortedList[i];
            for(j = i - 1; j >= 0 && (unsortedList[j] > tmp); j--) {
                unsortedList[j + 1] = unsortedList[j];
            }
            unsortedList[j + 1] = tmp;
        }
    }

    $(document).on('click', function(event) {
        if($(event.target).closest('#' + $scope.relationId).length === 0 &&
            $(event.target).closest('.' + $scope.relationId + "firstFilter").length === 0 &&
            $(event.target).closest('.' + $scope.relationId + "additionalFilter").length === 0 &&
            $(event.target).closest('#page-loading-overlay').length === 0) {
            $scope.showDialog = false;
            $scope.$evalAsync();
        }
    });

    $scope.filterDataByFirst = function(selected) {
        if(selected) {
            var paramAssigned = [];
            for(var i = 0; i < $scope.relation.assigned.length; i++) {
                paramAssigned.push({id: $scope.relation.assigned[i].id})
            }
            var dataObject = {
                selectedId: selected.id,
                assigned: $scope.relation.assigned
            };
            dataGen.postAsForm({}, dataObject, $scope.firstFilterEntryPoint).then(function(data) {
                $scope.relation.available = data.data.available;
                $scope.filterLeft($scope.searchText);
            });
        }
        else {
            $scope.relation.available = [];
            $scope.filterLeft("");
        }
    };
}

